module.exports = __webpack_public_path__ + "media/images/pla/pla13-8a5eb09443c0fa2b79368b0382578518.jpg";